<template lang="pug">
  app-modal(
    titulo="Visualizar beneficiários",
    :width="1000",
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      .modal
        informacoes-beneficiarios(
          :beneficiarios="beneficiarios"
          :cadastroOriginal="cadastroOriginal"
          :canRemove="true"
          @updateBeneficiariosLista="updateBeneficiariosLista"
        )
    template(slot="footer")
      .flex
        el-button.btn(
          id="cancelarRemocao",
          type="default",
          size="small",
          @click="$emit('closeModal')"
        )
          span.center
            b &nbsp Cancelar
        el-button.btn(
          id="confirmarRemocao",
          type="success",
          size="small",
          @click="confirmarRemocao"
        )
          span.center
            b &nbsp Confirmar

</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal.vue'
import InformacoesBeneficiarios from '@/components/informacoesCadastro/InformacoesBeneficiarios.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppModal,
    InformacoesBeneficiarios
  },

  props: {
    beneficiarios: {
      type: Array,
      required: true
    },
    cadastroOriginal: {
      type: Object,
      required: true
    },
    protocoloProcesso: {
      type: String,
      required: true
    }
  },

  mixins: [AppNotificacao],

  data () {
    return {
      beneficiariosUpdate: [...this.beneficiarios]
    }
  },

  methods: {
    ...mapActions({
      updateBeneficiariosByProtocolo: 'cadastro/updateBeneficiariosByProtocolo'
    }),

    confirmarRemocao () {
      this.confirmBox(
        'Tem certeza que deseja confirmar a remoção dos beneficiários? Será gerada uma nova versão do cadastro com a lista de beneficiários atualizada',
        this.$messages.TITULO_WARNING,
        async () => {
          await this.updateBeneficiariosByProtocolo({
            protocolo: this.protocoloProcesso,
            beneficiarios: this.beneficiariosUpdate
          })
          this.$emit('updateBeneficiarios')
          this.$emit('closeModal')
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            'Beneficiários atualizados com sucesso!'
          )
        },
        () => {}
      )
    },

    updateBeneficiariosLista (beneficiariosLista) {
      this.beneficiariosUpdate = [...beneficiariosLista]
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  height: 71vh;
}
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}
.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalBeneficiario.vue